var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_2653",
    "data-name": "Group 2653",
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.017,
    height: 35.017,
    viewBox: "0 0 35.017 35.017",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_654",
    "data-name": "Rectangle 654",
    d: "M17.508,0h0A17.508,17.508,0,0,1,35.017,17.508v0A17.508,17.508,0,0,1,17.508,35.017h0A17.508,17.508,0,0,1,0,17.509v0A17.508,17.508,0,0,1,17.508,0Z",
    transform: "translate(0 0)",
    fill: "#222221"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_86",
    "data-name": "Path 86",
    d: "M-131.929,118.644h4.262V107.971h2.973l.316-3.573h-3.29v-2.035c0-.843.169-1.176.983-1.176h2.306V97.478h-2.951c-3.171,0-4.6,1.4-4.6,4.07V104.4h-2.216v3.618h2.216Z",
    transform: "translate(146.769 -90.553)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/fb.4e3f84d086afdd0445ea383f7c7950d5.svg";
export { ForwardRef as ReactComponent };